import { checkFeature } from '@bybeam/platform-lib/features/check';
import { FeatureName, PaymentMethod, Program } from '@bybeam/platform-types';

export type PaymentRail = Exclude<PaymentMethod, PaymentMethod.External>;

export const PaymentMethodFeatures = {
  [PaymentMethod.Check]: FeatureName.PaymentsCheck,
  [PaymentMethod.DirectDeposit]: FeatureName.PaymentsDirectDeposit,
  [PaymentMethod.PhysicalCard]: FeatureName.PaymentsPrepaidCard,
  [PaymentMethod.VirtualCard]: FeatureName.PaymentsPrepaidCard,
  [PaymentMethod.Zelle]: FeatureName.PaymentsZelle,
};

export function getPaymentRails(program: Program): PaymentMethod[] {
  return Object.values(PaymentMethod).filter(
    (method) =>
      method !== PaymentMethod.External &&
      checkFeature(program?.features, PaymentMethodFeatures[method]),
  );
}

export function isPrepaidCard(method?: PaymentMethod): boolean {
  return method === PaymentMethod.PhysicalCard || method === PaymentMethod.VirtualCard;
}
